<template>
  <b-modal class="customer-show-ortho-ipr" id="customer-show-ortho-ipr" ref="modal" :title="dialog_title" hide-footer>
    <!-- MAIN DATA-->
    <div class="form-group row">
      <div class="col-md-3">
        <input type="date" id="show_ipr_created_at" class="form-control" v-model="created_at" />
        <label for="show_ipr_created_at" class="wabident-info">Fecha</label>
      </div>

      <div class="col-md-9">
        <input type="text" id="show_ipr_notes" class="form-control" v-model="notes" />
        <label for="show_ipr_notes" class="wabident-info">Notas</label>
      </div>
    </div>
    <!-- ODONTOGRAM -->
    <div class="form-group row">
      <div class="col" style="background-color: white;">
        <div class="customer-show-ortho-ipr__odontogram">
          <!-- UPPER ROW -->
          <div class="customer-show-ortho-ipr__odontogram-row">
            <div v-for="tooth, index in upper_row_teeth" :key="index" :data-tooth="tooth"
              class="customer-show-ortho-ipr__odontogram-tooth upper">
              <img :src="'/odontogram-v2/' + tooth + '.svg'">

              <input v-if="upper_row_keys_left[tooth]" :value='getUpperAmount(tooth, "left")'
                @input="setUpperAmount(tooth, $event, 'left')" type="number"
                class="customer-show-ortho-ipr__amount upper left" step="0.01">

              <input v-if="upper_row_keys[tooth]" :value='getUpperAmount(tooth)'
                @input="setUpperAmount(tooth, $event, null)" type="number" class="customer-show-ortho-ipr__amount upper"
                step="0.01">

              <input v-if="upper_row_keys_right[tooth]" :value='getUpperAmount(tooth, "right")'
                @input="setUpperAmount(tooth, $event, 'right')" type="number"
                class="customer-show-ortho-ipr__amount upper right" step="0.01">

            </div>
          </div>
          <!-- LOWER ROW -->
          <div class="customer-show-ortho-ipr__odontogram-row">
            <div v-for="tooth, index in lower_row_teeth" :key="index" :data-tooth="tooth"
              class="customer-show-ortho-ipr__odontogram-tooth lower">
              <img :src="'/odontogram-v2/' + tooth + '.svg'">


              <input v-if="lower_row_keys_left[tooth]" :value='getLowerAmount(tooth, "left")'
                @input="setLowerAmount(tooth, $event, 'left')" type="number"
                class="customer-show-ortho-ipr__amount lower left" step="0.01">

              <input v-if="lower_row_keys[tooth]" :value='getLowerAmount(tooth)'
                @input="setLowerAmount(tooth, $event, null)" type="number" class="customer-show-ortho-ipr__amount lower"
                step="0.01">

              <input v-if="lower_row_keys_right[tooth]" :value='getLowerAmount(tooth, "right")'
                @input="setLowerAmount(tooth, $event, 'right')" type="number"
                class="customer-show-ortho-ipr__amount lower right" step="0.01">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END ODONTOGRAM -->
    <!-- ACTION BUTTONS -->
    <div class="form-group row mt-5">
      <div class="col text-center">
        <button :disabled="is_valid" type="button" @click="onSubmit" class="btn btn-primary btn-wabident">
          <span v-if="is_loading">Guardando ...</span>
          <span v-else-if="is_editing">Modificar</span>
          <span v-else>Crear</span>
          <i v-if="is_loading" class="fas fa-circle-notch float-right"></i>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: ['customer'],
  data() {
    return {
      is_loading: false,
      ipr_id: null,
      created_at: null,
      notes: null,
      upper_arch: {},
      lower_arch: {},
      upper_row_adults: [
        18, 17, 16, 15, 14, 13, 12, 11, // UPPER LEFT
        21, 22, 23, 24, 25, 26, 27, 28, // UPPER RIGHT
      ],
      lower_row_adults: [
        48, 47, 46, 45, 44, 43, 42, 41, // LOWER LEFT
        31, 32, 33, 34, 35, 36, 37, 38, // LOWER RIGHT
      ],
      upper_row_keys: {
        // UPPER LEFT
        '18': '18-17',
        '17': '17-16',
        '16': '16-15',
        '15': '15-14',
        '14': '14-13',
        '13': '13-12',
        '12': '12-11',
        '11': '11-21',
        // UPPER RIGHT
        '21': '21-22',
        '22': '22-23',
        '23': '23-24',
        '24': '24-25',
        '25': '25-26',
        '26': '26-27',
        '27': '27-28',
        '28': null,
      },
      upper_row_keys_left: {
        // UPPER LEFT
        '18': '18-Izq',
        '17': '17-Izq',
        '16': '16-Izq',
        '15': '15-Izq',
        '14': '14-Izq',
        '13': '13-Izq',
        '12': '12-Izq',
        '11': '11-Izq',
        // UPPER RIGHT
        '21': '21-Izq',
        '22': '22-Izq',
        '23': '23-Izq',
        '24': '24-Izq',
        '25': '25-Izq',
        '26': '26-Izq',
        '27': '27-Izq',
        '28': '28-Izq',
      },
      upper_row_keys_right: {
        // UPPER LEFT
        '18': '18-Dcha',
        '17': '17-Dcha',
        '16': '16-Dcha',
        '15': '15-Dcha',
        '14': '14-Dcha',
        '13': '13-Dcha',
        '12': '12-Dcha',
        '11': '11-Dcha',
        // UPPER RIGHT
        '21': '21-Dcha',
        '22': '22-Dcha',
        '23': '23-Dcha',
        '24': '24-Dcha',
        '25': '25-Dcha',
        '26': '26-Dcha',
        '27': '27-Dcha',
        '28': '28-Dcha',
      },
      lower_row_keys: {
        // LOWER LEFT
        '48': '48-47',
        '47': '47-46',
        '46': '46-45',
        '45': '45-44',
        '44': '44-43',
        '43': '43-42',
        '42': '42-41',
        '41': '41-31',
        // LOWER RIGHT
        '31': '31-32',
        '32': '32-33',
        '33': '33-34',
        '34': '34-35',
        '35': '35-36',
        '36': '36-37',
        '37': '37-38',
        '38': null,
      },
      lower_row_keys_left: {
        // LOWER LEFT
        '48': '48-Izq',
        '47': '47-Izq',
        '46': '46-Izq',
        '45': '45-Izq',
        '44': '44-Izq',
        '43': '43-Izq',
        '42': '42-Izq',
        '41': '41-Izq',
        // LOWER RIGHT
        '31': '31-Izq',
        '32': '32-Izq',
        '33': '33-Izq',
        '34': '34-Izq',
        '35': '35-Izq',
        '36': '36-Izq',
        '37': '37-Izq',
        '38': '38-Izq',
      },
      lower_row_keys_right: {
        // LOWER LEFT
        '48': '48-Dcha',
        '47': '47-Dcha',
        '46': '46-Dcha',
        '45': '45-Dcha',
        '44': '44-Dcha',
        '43': '43-Dcha',
        '42': '42-Dcha',
        '41': '41-Dcha',
        // LOWER RIGHT
        '31': '31-Dcha',
        '32': '32-Dcha',
        '33': '33-Dcha',
        '34': '34-Dcha',
        '35': '35-Dcha',
        '36': '36-Dcha',
        '37': '37-Dcha',
        '38': '38-Dcha',
      },
    }
  },
  computed: {
    upper_row_teeth() {
      return this.upper_row_adults;
    },
    lower_row_teeth() {
      return this.lower_row_adults;
    },
    is_valid() {
      return this.created_at && this.is_loading;
    },
    is_editing() {
      return this.ipr_id != null;
    },
    dialog_title() {
      return this.ipr_id ? 'Editar IPR' : 'Crear IPR';
    },
    ...mapGetters(['clinic', 'msgwindow'])
  },
  methods: {
    getUpperToothKey(tooth, location = null) {
      let tooth_keys = null;
      switch (location) {
        case 'left':
          tooth_keys = this.upper_row_keys_left;
          break;
        case 'right':
          tooth_keys = this.upper_row_keys_right;
          break;
        default:
          tooth_keys = this.upper_row_keys;
      }

      return tooth_keys[tooth] || null;
    },
    getLowerToothKey(tooth, location = null) {
      let tooth_keys = null;
      switch (location) {
        case 'left':
          tooth_keys = this.lower_row_keys_left;
          break;
        case 'right':
          tooth_keys = this.lower_row_keys_right;
          break;
        default:
          tooth_keys = this.lower_row_keys;
      }
      return tooth_keys[tooth] || null;
    },
    // Upper arch getters
    getUpperAmount(tooth, location = null) {
      const key = this.getUpperToothKey(tooth, location);
      if (!key) {
        return null;
      }
      return this.upper_arch[key] || null;
    },
    // Lower arch getters
    getLowerAmount(tooth, location = null) {
      const key = this.getLowerToothKey(tooth, location)
      if (!key) {
        return null;
      }
      return this.lower_arch[key] || null;
    },
    setUpperAmount(tooth, ev, location = null) {
      const key = this.getUpperToothKey(tooth, location)

      console.log('setUpperAmount', {
        tooth: tooth,
        location: location,
        key: key,
        value: Number(ev.target.value),
      })

      if (key) {
        this.$set(this.upper_arch, key, Number(ev.target.value));
      }
    },
    setLowerAmount(tooth, ev, location) {
      const key = this.getLowerToothKey(tooth, location)

      console.log('setLowerAmount', {
        tooth: tooth,
        location: location,
        key: key,
        value: Number(ev.target.value),
      })

      if (key) {
        this.$set(this.lower_arch, key, Number(ev.target.value));
      }
    },
    onSubmit() {
      if (this.is_loading) {
        return true;
      }

      this.is_loading = true;

      let params = {
        created_at: this.created_at,
        notes: this.notes,
        upper_arch: this.upper_arch,
        lower_arch: this.lower_arch,
      }

      let uri = `/customer/${this.customer.id}/iprs`;
      if (this.is_editing) {
        uri = `/customer/${this.customer.id}/iprs/${this.ipr_id}`;
        params['_method'] = 'patch';
      }

      axios.post(uri, params)
        .then((response) => {
          this.msgwindow.success('IPR guardado');
          this.$refs.modal.hide();
          this.$emit('submit');
        }).catch((error) => {
          this.msgwindow.error('Error guardando IPR. Contacta con el Administrador')
        }).then(() => {
          this.is_loading = false;
        });
    },
    showNew(selected_tooth = []) {
      this.ipr_id = null;
      this.created_at = new Date().toISODate();
      this.upper_arch = {};
      this.lower_arch = {};
      this.notes = '';
      this.$refs.modal.show();
    },
    showEdit(ipr) {
      this.ipr_id = ipr.id;
      this.created_at = moment(ipr.created_at).format('YYYY-MM-DD');
      this.notes = ipr.notes;
      this.upper_arch = this.parseArchArray(ipr.upper_arch_array);
      this.lower_arch = this.parseArchArray(ipr.lower_arch_array);
      this.$refs.modal.show();
    },
    parseArchArray(arch_array) {
      let ret = {};
      if (!arch_array) {
        return ret;
      }

      for (const key in arch_array) {
        const value = arch_array[key].amount || 0.0;
        if (value) {
          ret[key] = value;
        }
      }

      return ret;
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss">
#customer-show-ortho-ipr {
  .modal-dialog {
    max-width: 95%;
  }

  .customer-show-ortho-ipr__odontogram {
    width: 100%;
    position: relative;
    display: flex;
    flex-flow: row wrap;
    gap: 60px;

    &:before {
      position: absolute;
      width: 100%;
      height: 1px;
      content: '';
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      background: var(--theme-shadow);
    }

    &:after {
      position: absolute;
      width: 1px;
      height: 100%;
      content: '';
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      background: var(--theme-shadow);
    }
  }

  .customer-show-ortho-ipr__odontogram-row {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1 1 100%;
  }

  .customer-show-ortho-ipr__odontogram-tooth {
    flex: 1 1 60px;
    position: relative;
    transition: background-color .3s;
    border-radius: 10px;

    /* Tooth image */
    img {
      box-sizing: border-box;
      width: 100%;
      padding: 10%;
      object-fit: contain;
      object-position: center center;
    }

    /* Tooth label */
    &::before {
      content: attr(data-tooth);
      position: absolute;
      left: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 3px;
      color: white;
      font-weight: 900;
      font-size: clamp(7px, 0.7vw, 14px);
      line-height: 1.5;
      padding: 0 5px;
      transform: translateX(-50%);
      background-color: var(--theme-color);
      z-index: 1;
    }

    &.upper::before {
      top: 10px;
    }

    &.lower::before {
      bottom: 10px;
    }
  }

  .customer-show-ortho-ipr__amount {
    position: absolute;
    background: var(--theme-grey-bg);
    color: var(--theme-text-color);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px;
    border: 1px var(--theme-grey) solid;
    border-radius: 10px;
    left: 100%;
    transform: translateX(-50%);
    z-index: 10;
    line-height: 1;
    font-size: clamp(6px, 0.7vw, 14px);
    max-width: 45px;
    text-align: center;
    -moz-appearance: textfield;

    &.upper {
      bottom: 12.5px;
    }

    &.lower {
      top: 12.5px;
    }

    &.upper.left {
      bottom: -20px;
      transform: translateX(calc(-100% - 5px));
      opacity: 0.8;
    }

    &.upper.right {
      left: 5px;
      bottom: -20px;
      transform: none;
      opacity: 0.8;
    }

    &.lower.left {
      top: -20px;
      transform: translateX(calc(-100% - 5px));
      opacity: 0.8;
    }

    &.lower.right {
      left: 5px;
      top: -20px;
      transform: none;
      opacity: 0.8;
    }
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

}
</style>
